<template lang="html">
  <div id="mainpage">
    <app-header></app-header>
    <div id="headerBlank"></div>
    <router-view></router-view>
  </div>
</template>

<script>
import AppHeader from '@/components/Mobile/header/SpAppHeader'
export default {
  components: {
    'app-header': AppHeader
  }
}
</script>

<style lang="css">
#headerBlank {
  height: 80px;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// SpMainPage.vue?46b81900